define('presentation/login/presentationObjects/declinedInformationPresentationObject',[],function() {
    return function(){
        var self = this;

        self.declinedDate = '';
        self.declinedAmount = '';
        self.pastDueBalance = '';
        self.paymentMethodId = '';
        self.autoCloseDate = '';
        self.billingMethod = '';
    };
});
